<template>
  <div>
    <el-alert
      title="下达后若车间已配组件仓，会按物料需求生成移库或领料到外协发料仓。到货会入库，并把尚未报工的数量同步记入工序完成量。录错可用「反到货」回退最近一次。单独报工只推进度、不入库。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.subcontractCode" clearable placeholder="外协单号" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.orderCode" clearable placeholder="工单号" style="width:150px" @keyup.enter.native="search" />
      <el-input v-model="query.companyName" clearable placeholder="供应商" style="width:150px" @keyup.enter.native="search" />
      <el-select v-model="query.subcontractState" clearable placeholder="状态" style="width:120px">
        <el-option label="草稿" value="00" />
        <el-option label="已下达" value="01" />
        <el-option label="进行中" value="02" />
        <el-option label="已关闭" value="03" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="subcontractCode" label="外协单号" width="190" />
      <el-table-column prop="orderCode" label="工单" width="160" />
      <el-table-column prop="companyName" label="供应商" min-width="140" show-overflow-tooltip />
      <el-table-column prop="planDate" label="计划日期" width="120" />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="stateType(row.subcontractState)">{{ stateLabel(row.subcontractState) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="340" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openView(row.subcontractId)">查看</el-button>
          <el-button type="text" :disabled="row.subcontractState !== '00'" @click="openEdit(row.subcontractId)">修改</el-button>
          <el-button type="text" :disabled="row.subcontractState !== '00'" @click="releaseRow(row.subcontractId)">下达</el-button>
          <el-button type="text" :disabled="row.subcontractState !== '01' && row.subcontractState !== '02'" @click="openAction(row.subcontractId, 'receive')">到货</el-button>
          <el-button type="text" :disabled="row.subcontractState === '00'" @click="unreceiveRow(row.subcontractId)">反到货</el-button>
          <el-button type="text" :disabled="row.subcontractState !== '01' && row.subcontractState !== '02'" @click="openAction(row.subcontractId, 'report')">报工</el-button>
          <el-button type="text" :disabled="row.subcontractState !== '01' && row.subcontractState !== '02'" @click="closeRow(row.subcontractId)">关闭</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.subcontractState !== '00'" @click="onDelete(row.subcontractId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />

    <el-dialog :title="form.subcontractId ? '修改外协单' : '新增外协单'" :visible.sync="visible" width="980px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="单号"><el-input v-model="form.subcontractCode" placeholder="留空自动生成" /></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产工单" required>
              <el-select v-model="form.orderId" filterable style="width:100%" @change="onOrderChange">
                <el-option v-for="o in orders" :key="o.orderId" :label="o.orderCode + ' / ' + (o.orderName || '')" :value="o.orderId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商" required>
              <el-select v-model="form.companyId" filterable style="width:100%">
                <el-option v-for="c in companies" :key="c.companyId" :label="c.companyName" :value="c.companyId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="计划日期">
              <el-date-picker v-model="form.planDate" type="date" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="到货入库仓" required>
              <el-select v-model="form.wareHouseId" filterable clearable placeholder="外协完工到货入库" style="width:100%">
                <el-option v-for="w in warehouses" :key="w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="外协发料仓" required>
              <el-select v-model="form.issueWareHouseId" filterable clearable placeholder="下达发料/移库目标仓" style="width:100%">
                <el-option v-for="w in warehouses" :key="'i' + w.wareHouseId" :label="w.wareHouseName" :value="w.wareHouseId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
          </el-col>
        </el-row>
        <div style="margin:8px 0">
          <strong>外协明细</strong>
          <el-button type="primary" size="mini" style="margin-left:8px" :disabled="!form.orderId" @click="loadTasks">从工单任务加载</el-button>
        </div>
        <el-table :data="form.lineList" border size="small">
          <el-table-column prop="operationName" label="工序" min-width="180" show-overflow-tooltip/>
          <el-table-column prop="taskCode" label="任务" min-width="180" show-overflow-tooltip/>
          <el-table-column label="计划数量" width="140">
            <template slot-scope="{ row }">
              <el-input-number v-model="row.plannedQty" :min="0.0001" :precision="4" size="mini" style="width:100%" />
            </template>
          </el-table-column>
          <el-table-column label="到货产品" min-width="180">
            <template slot-scope="{ row }">
              <el-select v-model="row.productId" clearable filterable size="mini" placeholder="可选" style="width:100%">
                <el-option v-for="p in products" :key="p.productId" :label="p.productNumber + ' / ' + (p.productName || '')" :value="p.productId" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70" align="center">
            <template slot-scope="{ $index }">
              <el-button type="text" size="mini" @click="form.lineList.splice($index, 1)">删</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="查看外协单" :visible.sync="viewVisible" width="980px">
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="外协单号">{{ view.subcontractCode }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ stateLabel(view.subcontractState) }}</el-descriptions-item>
        <el-descriptions-item label="生产工单">{{ view.orderCode }}</el-descriptions-item>
        <el-descriptions-item label="供应商">{{ view.companyName }}</el-descriptions-item>
        <el-descriptions-item label="计划日期">{{ view.planDate || '-' }}</el-descriptions-item>
        <el-descriptions-item label="到货入库仓">{{ view.wareHouseName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="外协发料仓">{{ view.issueWareHouseName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ view.remark || '-' }}</el-descriptions-item>
      </el-descriptions>
      <div style="margin:12px 0 8px"><strong>外协明细</strong></div>
      <el-table :data="view.lineList" border size="small">
        <el-table-column prop="operationName" label="工序" min-width="140" show-overflow-tooltip />
        <el-table-column prop="taskCode" label="任务" min-width="140" show-overflow-tooltip />
        <el-table-column prop="plannedQty" label="计划数量" width="100" align="right" />
        <el-table-column label="到货产品" min-width="180" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ productText(row) }}</template>
        </el-table-column>
        <el-table-column prop="receivedQty" label="已到货" width="90" align="right" />
        <el-table-column prop="reportedQty" label="已报工" width="90" align="right" />
      </el-table>
      <span slot="footer">
        <el-button @click="viewVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="actionType === 'receive' ? '外协到货确认' : '外协报工'" :visible.sync="actionVisible" width="860px">
      <el-table :data="actionLines" border size="small">
        <el-table-column prop="operationName" label="工序" min-width="140" />
        <el-table-column prop="taskCode" label="任务" min-width="140" />
        <el-table-column prop="plannedQty" label="计划" width="90" align="right" />
        <el-table-column prop="receivedQty" label="已到货" width="90" align="right" />
        <el-table-column prop="reportedQty" label="已报工" width="90" align="right" />
        <el-table-column label="本次数量" width="140">
          <template slot-scope="{ row }">
            <el-input-number v-model="row.qty" :min="0" :precision="4" size="mini" style="width:100%" />
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="actionVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitAction">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listSubcontractOrder, getSubcontractOrder, saveSubcontractOrder, updateSubcontractOrder,
  deleteSubcontractOrder, releaseSubcontractOrder, receiveSubcontractOrder, unreceiveSubcontractOrder,
  reportSubcontractOrder, closeSubcontractOrder
} from '../../api/subcontractOrder'
import { selectProductionOrder } from '../../api/productionOrder'
import { selectOrderTask } from '../../api/orderTask'
import { selectCompany } from '../../api/staff'
import { selectProduct } from '../../api/product'
import { selectEnabledWareHouse } from '../../api/warehouse'
import { getTechnology } from '../../api/technology'

export default {
  components: { ListPagination },
  data() {
    return {
      query: { subcontractCode: '', orderCode: '', companyName: '', subcontractState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      visible: false, saving: false, viewVisible: false, view: { lineList: [] },
      actionVisible: false, actionType: 'receive', actionId: '', actionLines: [],
      form: { subcontractId: '', subcontractCode: '', orderId: '', companyId: '', planDate: '', wareHouseId: '', issueWareHouseId: '', remark: '', version: 0, lineList: [] },
      orders: [], companies: [], warehouses: [], products: []
    }
  },
  created() {
    this.load()
    selectProductionOrder().then(res => { this.orders = res.data || [] }).catch(() => {})
    selectCompany().then(res => { this.companies = res.data || [] }).catch(() => {})
    selectEnabledWareHouse().then(res => { this.warehouses = res.data || [] }).catch(() => {})
    selectProduct().then(res => { this.products = res.data || [] }).catch(() => {})
  },
  methods: {
    stateLabel(s) { return { '00': '草稿', '01': '已下达', '02': '进行中', '03': '已关闭' }[s] || s },
    stateType(s) { return { '00': 'info', '01': '', '02': 'warning', '03': 'success' }[s] || 'info' },
    emptyForm() {
      return { subcontractId: '', subcontractCode: '', orderId: '', companyId: '', planDate: '', wareHouseId: '', issueWareHouseId: '', remark: '', version: 0, lineList: [] }
    },
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listSubcontractOrder({
        currentPage: this.page, pageSize: this.pageSize,
        subcontractCode: this.query.subcontractCode,
        orderCode: this.query.orderCode,
        companyName: this.query.companyName,
        subcontractState: this.query.subcontractState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    productText(row) {
      if (!row) return '-'
      if (row.productNumber || row.productName) {
        return (row.productNumber || '') + (row.productName ? ' / ' + row.productName : '')
      }
      return '-'
    },
    openView(id) {
      getSubcontractOrder(id).then(res => {
        const d = res.data || {}
        this.view = Object.assign({ lineList: [] }, d)
        this.viewVisible = true
      })
    },
    openEdit(id) {
      if (!id) {
        this.form = this.emptyForm()
        this.visible = true
        return
      }
      getSubcontractOrder(id).then(res => {
        const d = res.data || {}
        this.form = {
          subcontractId: d.subcontractId,
          subcontractCode: d.subcontractCode,
          orderId: d.orderId,
          companyId: d.companyId,
          planDate: d.planDate,
          wareHouseId: d.wareHouseId || '',
          issueWareHouseId: d.issueWareHouseId || '',
          remark: d.remark,
          version: d.version,
          lineList: (d.lineList || []).map(l => ({
            operationId: l.operationId,
            operationName: l.operationName,
            technologyOperationId: l.technologyOperationId,
            taskId: l.taskId,
            taskCode: l.taskCode,
            productId: l.productId || '',
            plannedQty: Number(l.plannedQty)
          }))
        }
        this.visible = true
      })
    },
    onOrderChange() {
      this.form.lineList = []
      this.loadTasks()
    },
    loadTasks() {
      if (!this.form.orderId) return
      const order = (this.orders || []).find(o => o.orderId === this.form.orderId) || {}
      const orderProductId = order.productId || ''
      const techPromise = order.technologyId
        ? getTechnology(order.technologyId).then(res => res.data || {}).catch(() => ({}))
        : Promise.resolve({})
      Promise.all([selectOrderTask(this.form.orderId), techPromise]).then(([taskRes, tech]) => {
        const outByOp = {}
        ;((tech.productOutList) || []).forEach(out => {
          if (!out || !out.operationComponentId || !out.productId || out.waste === '1') return
          const key = out.operationComponentId
          if (!outByOp[key]) {
            outByOp[key] = out.productId
          }
        })
        const tasks = (taskRes.data || []).filter(t => t.isSubcontracting === '1')
        this.form.lineList = tasks.map((t, idx) => ({
          lineSort: idx + 1,
          operationId: t.operationId,
          operationName: t.operationName,
          technologyOperationId: t.technologyOperationId,
          taskId: t.taskId,
          taskCode: t.taskCode,
          productId: outByOp[t.technologyOperationId] || orderProductId || '',
          plannedQty: Number(t.plannedQty || 1)
        }))
        if (!this.form.lineList.length) {
          this.$message.warning('该工单无外协工序任务（请先在工序主数据勾选外协并生成任务）')
        }
      })
    },
    submit() {
      if (!this.form.orderId) { this.$message.warning('请选择工单'); return }
      if (!this.form.companyId) { this.$message.warning('请选择供应商'); return }
      if (!this.form.wareHouseId) { this.$message.warning('请选择到货入库仓'); return }
      if (!this.form.issueWareHouseId) { this.$message.warning('请选择外协发料仓'); return }
      if (!(this.form.lineList || []).length) { this.$message.warning('请加载外协明细'); return }
      this.saving = true
      const req = this.form.subcontractId ? updateSubcontractOrder(this.form) : saveSubcontractOrder(this.form)
      req.then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.search()
      }).finally(() => { this.saving = false })
    },
    unreceiveRow(id) {
      this.$confirm('将回退最近一次到货，冲回入库、已到货，以及该次同步的报工和完成量。确定继续?', '提示', { type: 'warning' }).then(() => {
        unreceiveSubcontractOrder(id).then(() => { this.$message.success('已回退'); this.load() })
      }).catch(() => {})
    },
    releaseRow(id) {
      this.$confirm('确认下达该外协单?', '提示', { type: 'warning' }).then(() => {
        releaseSubcontractOrder(id).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    closeRow(id) {
      this.$confirm('确认关闭该外协单?', '提示', { type: 'warning' }).then(() => {
        closeSubcontractOrder(id).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    onDelete(id) {
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteSubcontractOrder([id]).then(() => { this.$message.success('操作成功'); this.load() })
      }).catch(() => {})
    },
    openAction(id, type) {
      this.actionType = type
      this.actionId = id
      getSubcontractOrder(id).then(res => {
        this.actionLines = ((res.data || {}).lineList || []).map(l => {
          const planned = Number(l.plannedQty || 0)
          const done = type === 'receive' ? Number(l.receivedQty || 0) : Number(l.reportedQty || 0)
          let remain = planned - done
          if (remain < 0) remain = 0
          return Object.assign({}, l, {
            qty: type === 'receive' && remain > 0 ? remain : null
          })
        })
        this.actionVisible = true
      })
    },
    submitAction() {
      const payload = {
        subcontractId: this.actionId,
        lineList: this.actionLines.filter(l => l.qty && Number(l.qty) > 0).map(l => ({ lineId: l.lineId, qty: l.qty }))
      }
      if (!payload.lineList.length) { this.$message.warning('请填写本次数量'); return }
      this.saving = true
      const req = this.actionType === 'receive' ? receiveSubcontractOrder(payload) : reportSubcontractOrder(payload)
      req.then(() => {
        this.$message.success('操作成功')
        this.actionVisible = false
        this.load()
      }).finally(() => { this.saving = false })
    }
  }
}
</script>
